import { ChevronLeft, ChevronRight, LogOut } from "lucide-react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../components/sidebar.css";

export default function Sidebar({ role, menuItems, handleLogout, username }) {
  const [collapsed, setCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const base = role === "FRUITORE" ? "/menufruitore" : "/menuconfig"

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""} ${role.toLowerCase()}`}>
      <div className="sidebar-top">
        {!collapsed && <h2 className="logo-text">Menu {role}</h2>}

        <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      <nav className="menu">
        {menuItems.map((item) => (
          <button
            key={item.name}
            onClick={() => navigate(`${base}/${item.path}`)}
            className={`menu-item ${location.pathname.includes(item.path) ? "active" : ""}`}
          >
            {item.icon}
            {!collapsed && <span className="label">{item.name}</span>}
          </button>
        ))}
      </nav>

      <button className="menu-item" onClick={() => setShowModal(true)}>
        <LogOut size={20} />
        {!collapsed && <span className="label">Logout</span>}
      </button>

      <div className="user">
        <div className="avatar">{username?.charAt(0).toUpperCase()}</div>
        {!collapsed && <span className="username">{username}</span>}
      </div>

      {showModal && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <p>Vuoi uscire dall'area personale?</p>
            <div className="logout-modal-buttons">
              <button className="confirm-btn" onClick={handleLogout}>Esci</button>
              <button className="cancel-btn" onClick={() => setShowModal(false)}>Annulla</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
